import { Presentation } from '@visiba/presentation';
import { v4 } from 'uuid';
import { WorkerTaskState } from './common';
import { FileWorkerPresentationModel } from './mod';

export class FileWorkerStale {
	public readonly presentation = Presentation.create<FileWorkerPresentationModel>({
		fileState: WorkerTaskState.Pristine,
		failedReason: null,
	});
	public readonly id: string;
	public readonly fileName: string;
	public readonly fileType: string;
	public readonly fileSize: number;
	public readonly downloadUrl: string;
	public readonly thumbnailUrl: string | null;

	constructor({
		fileName,
		fileType,
		fileSize,
		downloadUrl,
		thumbnailUrl,
	}: {
		fileName: string;
		fileType: string;
		fileSize: number;
		downloadUrl: string;
		thumbnailUrl?: string;
	}) {
		this.id = v4();
		this.fileName = fileName;
		this.fileType = fileType;
		this.fileSize = fileSize;
		this.downloadUrl = downloadUrl;
		this.thumbnailUrl = thumbnailUrl ?? null;
	}

	public getThumbnail(): string | null {
		// TODO: DON'T USE DOWNLOAD URL FOR THUMBNAIL !!!
		if (this.fileType.includes('image')) {
			if (this.thumbnailUrl != null) {
				return this.thumbnailUrl;
			}

			return this.downloadUrl;
		}

		return null;
	}
}
